<div class="modal-overlay">
  <div class="modal-content">
    <div class="header_title">
      <h3>{{data.title}}</h3>
    </div>
    <div class="confirmation-body">
      <div class="msg-title">
        <span *ngIf="data.message" [innerHtml]="data.message"></span>
      </div>

      <div class="confirmation-msg" *ngIf="data.warningMessage">
        <svg width="65" height="65" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z"
            fill="#FF7F00" />
          <path
            d="M22.8842 12.532C22.5382 11.878 21.4622 11.878 21.1162 12.532L12.1162 29.532C11.9522 29.842 11.9622 30.216 12.1432 30.515C12.3242 30.816 12.6492 31 13.0002 31H31.0002C31.3512 31 31.6762 30.816 31.8562 30.516C32.0382 30.216 32.0472 29.842 31.8832 29.533L22.8842 12.532ZM23.0002 28H21.0002V26H23.0002V28ZM21.0002 24V19H23.0002L23.0012 24H21.0002Z"
            fill="#F7F5F5" />
        </svg>
        <span>{{data.warningMessage}}</span>
      </div>

      <div class="confirmation-input-group" *ngIf="data.confirmationPrompt">
        <label>{{data.confirmPlaceholder || 'Type to confirm'}}</label>
        <input
          type="text"
          class="confirmation-input"
          [(ngModel)]="confirmationInput"
          [placeholder]="data.confirmPlaceholder || 'Type to confirm'" />
      </div>

      <div class="button-group">
        <button type="button" class="cancel-btn" (click)="modalInstance.dismiss()">{{data.declineText ||
          'Decline'}}</button>
        <button type="submit" class="remove-btn" [disabled]="isLoading || isConfirmDisabled" (click)="handleConfirm()">
          <span *ngIf="isLoading" class="spinner-border"></span>
          <span *ngIf="!isLoading">{{data.confirmText || 'Confirm'}}</span>
        </button>
      </div>
    </div>
  </div>
</div>